import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate  } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Modal, Spinner } from "react-bootstrap";

/*** 
@purpose : Functional Component
@Parameter : {props}
**/
function HospitalFunctions(props) {
  const navigate = useNavigate();
  const [lang] = useTranslation("language");
  const [customerNotFound, setCustomerNotFound] = useState();
  const [details, setDetails] = useState({});
  const [implementationFacilityData, setImplementationFacilityData] =
    useState("");
  const [medicalEquipmentData, setMedicalEquipmentData] = useState("");
  const [policyHealthData, setPolicyHealthData] = useState("");
  const [clinicalTrainingList, setClinicalTrainingList] = useState([]);
  const [subsidiaryList, setSubsidiaryList] = useState([]);

  useEffect(() => {
    let list = [];
    let list1 = [];
    setDetails(props.details);
    props.details &&
      props.details
        .jpUltmarcClinicalTrainingHospitalCustomerUnifiedCustomerCode &&                        /* SAKAMOTO: AHDD-5861 Ultmarc code change */
      props.details.jpUltmarcClinicalTrainingHospitalCustomerUnifiedCustomerCode.map(           /* SAKAMOTO: AHDD-5861 Ultmarc code change */
        /*        .jpUltmarcClinicalTrainingHospitalCustomerLegacyUnifiedCustomerCode &&                /* SAKAMOTO: AHDD-5861 Ultmarc code change */
        /*      props.details.jpUltmarcClinicalTrainingHospitalCustomerLegacyUnifiedCustomerCode.map(   /* SAKAMOTO: AHDD-5861 Ultmarc code change */
        (item) => {
          list.push(item);
        }
      );
    props.details &&
      props.details.subsidiaryHospitalUnifiedCustomerCode &&                 /* SAKAMOTO: AHDD-5861 Ultmarc code change */
      props.details.subsidiaryHospitalUnifiedCustomerCode.map((item) => {    /* SAKAMOTO: AHDD-5861 Ultmarc code change */
        /*      props.details.subsidiaryHospitalLegacyUnifiedCustomerCode &&               /* SAKAMOTO: AHDD-5861 Ultmarc code change */
        /*      props.details.subsidiaryHospitalLegacyUnifiedCustomerCode.map((item) => {  /* SAKAMOTO: AHDD-5861 Ultmarc code change */
        list1.push(item);
      });
    setClinicalTrainingList(list);
    setSubsidiaryList(list1);
    getImplementationFacilityData();
    getMedicalEquipmentData();
    getPolicyHealthData();
  }, []);

  /*** 
    @purpose : Change route
    @Parameter : {e, page}
    **/
  const changeRoute = (e, page) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    navigate(page);
  };

  /*** 
    @purpose : Get implementation facility data
    @Parameter : {}
    **/
  function getImplementationFacilityData() {
    let y = "";
    for (var i = 1; i <= 40; i++) {
      let x = `advanced_medical_care_implementation_facility_${i}_code`;
      y += props.details[x] ? (i === 1 ? "" : ",") + props.details[x] : "";
    }
    setImplementationFacilityData(y);
  }

  /*** 
    @purpose : Get medical equipment data
    @Parameter : {}
    **/
  function getMedicalEquipmentData() {
    let y = "";
    for (var i = 1; i < 20; i++) {
      let x = `advanced_medical_equipment_${i}`;
      y += props.details[x] ? (i === 1 ? "" : ",") + props.details[x] : "";
    }
    setMedicalEquipmentData(y);
  }

  /*** 
    @purpose : Get policy health data
    @Parameter : {}
    **/
  function getPolicyHealthData() {
    let y = "";
    for (var i = 1; i < 20; i++) {
      let x = `details.policy_health_care_${i}_code`;
      y += details.x ? (i === 1 ? "" : ",") + details.x : "";
    }
    setPolicyHealthData(y.substring(0, y.length - 1));
  }

  const goToOrgCustomer = (id) => {
    navigate(`/organizationInfo?orgId=${id}`);
    window.location.reload();
  };

  return (
    <>
      <div className="org-main">
        <div className="org-wrapper1">
          <h4 className="primary-title">
            {lang("OrganizationMenu.hospitalFunctions")}
          </h4>
          <div className="card">
            <div className="card-body">
              <div className="table-responsive mb-0 max-height">
                <table className="table" aria-describedby="table">
                  <thead>
                    <tr>
                      <th scope="col">
                        <div className="cursor-pointer">
                          {lang("customerRequestStatus.item")}
                        </div>
                      </th>
                      <th scope="col">
                        <div className="cursor-pointer">
                          {lang("organizationDetails.flag")}
                        </div>
                      </th>
                      <th scope="col">
                        <div className="cursor-pointer">
                          {lang("organizationDetails.value")}
                        </div>
                      </th>
                      <th scope="col">
                        <div className="cursor-pointer">
                          {lang("organizationDetails.approvedDate")}
                        </div>
                      </th>
                      <th scope="col">
                        <div className="cursor-pointer">
                          {lang("organizationDetails.cancelledDate")}
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>検査項目-微生物</td>
                      <td>
                        {details && details.inspection_item_flag_microbe
                          ? details.inspection_item_flag_microbe
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>検査項目-血清</td>
                      <td>
                        {details && details.inspection_item_flag_serum
                          ? details.inspection_item_flag_serum
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>検査項目-血液</td>
                      <td>
                        {details && details.inspection_item_flag_blood
                          ? details.inspection_item_flag_blood
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>検査項目-病理</td>
                      <td>
                        {details && details.inspection_item_flag_pathology
                          ? details.inspection_item_flag_pathology
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>検査項目-寄生虫</td>
                      <td>
                        {details && details.inspection_item_flag_parasites
                          ? details.inspection_item_flag_parasites
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>検査項目-生化</td>
                      <td>
                        {details && details.inspection_item_flag_biochemistry
                          ? details.inspection_item_flag_biochemistry
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>検査項目-RI</td>
                      <td>
                        {details && details.inspection_item_flag_ri
                          ? details.inspection_item_flag_ri
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>DPC対象病院</td>
                      <td>
                        {details && details.dpc_hospital_flag
                          ? details.dpc_hospital_flag
                          : ""}
                      </td>
                      <td>-</td>
                      <td>
                        {details && details.dpc_hospital_issued_date
                          ? details.dpc_hospital_issued_date
                          : ""}
                      </td>
                      <td>
                        {details && details.dpc_hospital_canceled_date
                          ? details.dpc_hospital_canceled_date
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>DPC準備病院</td>
                      <td>
                        {details && details.dpc_prepared_hospital_flag
                          ? details.dpc_prepared_hospital_flag
                          : ""}
                      </td>
                      <td>-</td>
                      <td>
                        {details && details.dpc_prepared_hospital_approved_year
                          ? details.dpc_prepared_hospital_approved_year
                          : ""}
                      </td>
                      <td>
                        {details && details.dpc_prepared_hospital_canceled_date
                          ? details.dpc_prepared_hospital_canceled_date
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>がん診療連携拠点病院</td>
                      <td>
                        {details &&
                          details.cancer_treatment_center_hospital_flag
                          ? details.cancer_treatment_center_hospital_flag
                          : ""}
                      </td>
                      <td>-</td>
                      <td>
                        {details &&
                          details.cancer_treatment_center_hospital_issued_date
                          ? details.cancer_treatment_center_hospital_issued_date
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.cancer_treatment_center_hospital_canceled_date
                          ? details.cancer_treatment_center_hospital_canceled_date
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>特定機能病院</td>
                      <td>
                        {details && details.specific_function_hospital_flag
                          ? details.specific_function_hospital_flag
                          : ""}
                      </td>
                      <td>-</td>
                      <td>
                        {details &&
                          details.specific_function_hospital_approved_date
                          ? details.specific_function_hospital_approved_date
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.specific_function_hospital_canceled_date
                          ? details.specific_function_hospital_canceled_date
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>地域医療支援病院</td>
                      <td>
                        {details &&
                          details.regional_medical_support_hospital_flag
                          ? details.regional_medical_support_hospital_flag
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.regional_medical_support_hospital_referral_fee_rate
                          ? details.regional_medical_support_hospital_referral_fee_rate
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.regional_medical_support_hospital_approved_date
                          ? details.regional_medical_support_hospital_approved_date
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.regional_medical_support_hospital_canceled_date
                          ? details.regional_medical_support_hospital_canceled_date
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>超急性期脳卒中加算</td>
                      <td>
                        {details &&
                          details.ultra_acute_cerebral_apoplexy_additional_fee_flag
                          ? details.ultra_acute_cerebral_apoplexy_additional_fee_flag
                          : ""}
                      </td>
                      <td>-</td>
                      <td>
                        {details &&
                          details.ultra_acute_cerebral_apoplexy_additional_fee_approved_date
                          ? details.ultra_acute_cerebral_apoplexy_additional_fee_approved_date
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.ultra_acute_cerebral_apoplexy_additional_fee_canceled_date
                          ? details.ultra_acute_cerebral_apoplexy_additional_fee_canceled_date
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>総合入院体制加算</td>
                      <td>
                        {details &&
                          details.total_hospitalization_system_addition_flag
                          ? details.total_hospitalization_system_addition_flag
                          : ""}
                      </td>
                      <td>-</td>
                      <td>
                        {details &&
                          details.total_hospitalization_system_addition_approved_date
                          ? details.total_hospitalization_system_addition_approved_date
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.total_hospitalization_system_addition_canceled_date
                          ? details.total_hospitalization_system_addition_canceled_date
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>医師事務作業補助体制加算</td>
                      <td>
                        {details &&
                          details.doctor_clerical_work_support_system_addition_flag
                          ? details.doctor_clerical_work_support_system_addition_flag
                          : ""}
                      </td>
                      <td>-</td>
                      <td>
                        {details &&
                          details.doctor_clerical_work_support_system_approved_date
                          ? details.doctor_clerical_work_support_system_approved_date
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.doctor_clerical_work_support_system_canceled_date
                          ? details.doctor_clerical_work_support_system_canceled_date
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>診療録管理体制加算</td>
                      <td>
                        {details &&
                          details.medical_record_management_system_addition_flag
                          ? details.medical_record_management_system_addition_flag
                          : ""}
                      </td>
                      <td>-</td>
                      <td>
                        {details &&
                          details.medical_record_management_system_addition_approved_date
                          ? details.medical_record_management_system_addition_approved_date
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.medical_record_management_system_addition_canceled_date
                          ? details.medical_record_management_system_addition_canceled_date
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>医療安全対策加算</td>
                      <td>
                        {details &&
                          details.medical_safety_measures_addition_flag
                          ? details.medical_safety_measures_addition_flag
                          : ""}
                      </td>
                      <td>-</td>
                      <td>
                        {details &&
                          details.medical_safety_measures_addition_approved_date
                          ? details.medical_safety_measures_addition_approved_date
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.medical_safety_measures_addition_canceled_date
                          ? details.medical_safety_measures_addition_canceled_date
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>褥瘡ﾊｲﾘｽｸ患者ｹｱ加算</td>
                      <td>
                        {details &&
                          details.pressure_ulcer_high_risk_patient_care_addition_flag
                          ? details.pressure_ulcer_high_risk_patient_care_addition_flag
                          : ""}
                      </td>
                      <td></td>
                      <td>
                        {details &&
                          details.pressure_ulcer_high_risk_patient_care_addition_approved_date
                          ? details.pressure_ulcer_high_risk_patient_care_addition_approved_date
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.pressure_ulcer_high_risk_patient_care_addition_canceled_date
                          ? details.pressure_ulcer_high_risk_patient_care_addition_canceled_date
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>地域連携小児夜間･休日診療料</td>
                      <td>
                        {details &&
                          details.regional_coop_childrens_medical_treatment_fee_flag
                          ? details.regional_coop_childrens_medical_treatment_fee_flag
                          : ""}
                      </td>
                      <td></td>
                      <td>
                        {details &&
                          details.regional_coop_childrens_medical_treatment_fee_approved_date
                          ? details.regional_coop_childrens_medical_treatment_fee_approved_date
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.regional_coop_childrens_medical_treatment_fee_canceled_date
                          ? details.regional_coop_childrens_medical_treatment_fee_canceled_date
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>開放型病院</td>
                      <td>
                        {details && details.open_hospital_flag
                          ? details.open_hospital_flag
                          : ""}
                      </td>
                      <td></td>
                      <td>
                        {details && details.open_hospital_approved_date
                          ? details.open_hospital_approved_date
                          : ""}
                      </td>
                      <td>
                        {details && details.open_hospital_canceled_date
                          ? details.open_hospital_canceled_date
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>地域連携ｸﾘﾃｨｶﾙﾊﾟｽ</td>
                      <td>
                        {details &&
                          details.regional_collaboration_critical_path_flag
                          ? details.regional_collaboration_critical_path_flag
                          : ""}
                      </td>
                      <td>
                        {details &&
                          (details.regional_collaboration_critical_path_code_1
                            ? details.regional_collaboration_critical_path_code_1
                            : "") +
                          (details.regional_collaboration_critical_path_code_2
                            ? "," +
                            details.regional_collaboration_critical_path_code_2
                            : "") +
                          (details.regional_collaboration_critical_path_code_3
                            ? "," +
                            details.regional_collaboration_critical_path_code_3
                            : "") +
                          (details.regional_collaboration_critical_path_code_4
                            ? "," +
                            details.regional_collaboration_critical_path_code_4
                            : "") +
                          (details.regional_collaboration_critical_path_code_5
                            ? "," +
                            details.regional_collaboration_critical_path_code_5
                            : "") +
                          (details.regional_collaboration_critical_path_code_6
                            ? "," +
                            details.regional_collaboration_critical_path_code_6
                            : "") +
                          (details.regional_collaboration_critical_path_code_7
                            ? "," +
                            details.regional_collaboration_critical_path_code_7
                            : "") +
                          (details.regional_collaboration_critical_path_code_8
                            ? "," +
                            details.regional_collaboration_critical_path_code_8
                            : "") +
                          (details.regional_collaboration_critical_path_code_9
                            ? "," +
                            details.regional_collaboration_critical_path_code_9
                            : "") +
                          (details.regional_collaboration_critical_path_code_10
                            ? "," +
                            details.regional_collaboration_critical_path_code_10
                            : "") +
                          (details.regional_collaboration_critical_path_code_11
                            ? "," +
                            details.regional_collaboration_critical_path_code_11
                            : "") +
                          (details.regional_collaboration_critical_path_code_12
                            ? "," +
                            details.regional_collaboration_critical_path_code_12
                            : "") +
                          (details.regional_collaboration_critical_path_code_13
                            ? "," +
                            details.regional_collaboration_critical_path_code_13
                            : "") +
                          (details.regional_collaboration_critical_path_code_14
                            ? "," +
                            details.regional_collaboration_critical_path_code_14
                            : "") +
                          (details.regional_collaboration_critical_path_code_15
                            ? "," +
                            details.regional_collaboration_critical_path_code_15
                            : "") +
                          (details.regional_collaboration_critical_path_code_16
                            ? "," +
                            details.regional_collaboration_critical_path_code_16
                            : "") +
                          (details.regional_collaboration_critical_path_code_17
                            ? "," +
                            details.regional_collaboration_critical_path_code_17
                            : "") +
                          (details.regional_collaboration_critical_path_code_18
                            ? "," +
                            details.regional_collaboration_critical_path_code_18
                            : "") +
                          (details.regional_collaboration_critical_path_code_19
                            ? "," +
                            details.regional_collaboration_critical_path_code_19
                            : "") +
                          (details.regional_collaboration_critical_path_code_20
                            ? "," +
                            details.regional_collaboration_critical_path_code_20
                            : "")}
                      </td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>薬剤管理指導料</td>
                      <td>
                        {details && details.drug_management_guidance_fee_flag
                          ? details.drug_management_guidance_fee_flag
                          : ""}
                      </td>
                      <td></td>
                      <td>
                        {details &&
                          details.drug_management_guidance_fee_approved_date
                          ? details.drug_management_guidance_fee_approved_date
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.drug_management_guidance_fee_canceled_date
                          ? details.drug_management_guidance_fee_canceled_date
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>画像診断管理加算</td>
                      <td>
                        {details &&
                          details.diagnostic_imaging_management_addition_flag
                          ? details.diagnostic_imaging_management_addition_flag
                          : ""}
                      </td>
                      <td></td>
                      <td>
                        {details &&
                          details.diagnostic_imaging_management_addition_approved_date
                          ? details.diagnostic_imaging_management_addition_approved_date
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.diagnostic_imaging_management_addition_canceled_date
                          ? details.diagnostic_imaging_management_addition_canceled_date
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>外来化学療法加算</td>
                      <td>
                        {details &&
                          details.outpatient_chemotherapy_addition_flag
                          ? details.outpatient_chemotherapy_addition_flag
                          : ""}
                      </td>
                      <td></td>
                      <td>
                        {details &&
                          details.outpatient_chemotherapy_addition_approved_date
                          ? details.outpatient_chemotherapy_addition_approved_date
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.outpatient_chemotherapy_addition_canceled_date
                          ? details.outpatient_chemotherapy_addition_canceled_date
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>疾患別ﾘﾊﾋﾞﾘﾃｰｼｮﾝ料</td>
                      <td>
                        {details && details.rehabilitation_fees_by_disease_flag
                          ? details.rehabilitation_fees_by_disease_flag
                          : ""}
                      </td>
                      <td>
                        {details &&
                          (details.rehabilitation_fees_by_disease_code_1
                            ? details.rehabilitation_fees_by_disease_code_1
                            : "") +
                          (details.rehabilitation_fees_by_disease_code_2
                            ? "," +
                            details.rehabilitation_fees_by_disease_code_2
                            : "") +
                          (details.rehabilitation_fees_by_disease_code_3
                            ? "," +
                            details.rehabilitation_fees_by_disease_code_3
                            : "") +
                          (details.rehabilitation_fees_by_disease_code_4
                            ? "," +
                            details.rehabilitation_fees_by_disease_code_4
                            : "") +
                          (details.rehabilitation_fees_by_disease_code_5
                            ? "," +
                            details.rehabilitation_fees_by_disease_code_5
                            : "") +
                          (details.rehabilitation_fees_by_disease_code_6
                            ? "," +
                            details.rehabilitation_fees_by_disease_code_6
                            : "") +
                          (details.rehabilitation_fees_by_disease_code_7
                            ? "," +
                            details.rehabilitation_fees_by_disease_code_7
                            : "") +
                          (details.rehabilitation_fees_by_disease_code_8
                            ? "," +
                            details.rehabilitation_fees_by_disease_code_8
                            : "") +
                          (details.rehabilitation_fees_by_disease_code_9
                            ? "," +
                            details.rehabilitation_fees_by_disease_code_9
                            : "") +
                          (details.rehabilitation_fees_by_disease_code_10
                            ? "," +
                            details.rehabilitation_fees_by_disease_code_10
                            : "")}
                      </td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>麻酔管理料</td>
                      <td>
                        {details && details.anesthesia_management_fee_flag
                          ? details.anesthesia_management_fee_flag
                          : ""}
                      </td>
                      <td></td>
                      <td>
                        {details &&
                          details.anesthesia_management_fee_approved_date
                          ? details.anesthesia_management_fee_approved_date
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.anesthesia_management_fee_canceled_date
                          ? details.anesthesia_management_fee_canceled_date
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>在宅療養支援病院･診療所</td>
                      <td>
                        {details &&
                          details.home_care_support_hospitals_and_clinics_flag
                          ? details.home_care_support_hospitals_and_clinics_flag
                          : ""}
                      </td>
                      <td></td>
                      <td>
                        {details &&
                          details.home_care_support_hospitals_and_clinics_approved_date
                          ? details.home_care_support_hospitals_and_clinics_approved_date
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.home_care_support_hospitals_and_clinics_canceled_date
                          ? details.home_care_support_hospitals_and_clinics_canceled_date
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>在宅時医学総合管理料</td>
                      <td>
                        {details &&
                          details.general_medical_management_fee_at_home_flag
                          ? details.general_medical_management_fee_at_home_flag
                          : ""}
                      </td>
                      <td></td>
                      <td>
                        {details &&
                          details.general_medical_management_fee_at_home_approved_date
                          ? details.general_medical_management_fee_at_home_approved_date
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.general_medical_management_fee_at_home_canceled_date
                          ? details.general_medical_management_fee_at_home_canceled_date
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>在宅がん医療総合診療料</td>
                      <td>
                        {details &&
                          details.gen_medical_care_fee_for_late_stage_medi_care_at_home_flag
                          ? details.gen_medical_care_fee_for_late_stage_medi_care_at_home_flag
                          : ""}
                      </td>
                      <td></td>
                      <td>
                        {details &&
                          details.gen_medical_care_fee_for_late_stage_medi_care_at_home_app_dt
                          ? details.gen_medical_care_fee_for_late_stage_medi_care_at_home_app_dt
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.gen_medical_care_fee_for_late_stage_medi_care_at_home_canc_dt
                          ? details.gen_medical_care_fee_for_late_stage_medi_care_at_home_canc_dt
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>ケアミックス区分</td>
                      <td>-</td>
                      <td>
                        {details && details.care_mix_type
                          ? details.care_mix_type
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>完全型・移行型区分</td>
                      <td>-</td>
                      <td>
                        {details && details.complete_and_migratory_type
                          ? details.complete_and_migratory_type
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td rowSpan="3">療養型病床群</td>
                      <td rowSpan="3">
                        {details &&
                          details.recuperation_type_hospital_bed_group_flag
                          ? details.recuperation_type_hospital_bed_group_flag
                          : ""}
                      </td>
                      <td>
                        医療型 看護種別:
                        {details &&
                          details.recuperation_type_hospital_bed_group_medical_type_nursing_type
                          ? details.recuperation_type_hospital_bed_group_medical_type_nursing_type
                          : "" + ","}
                        病床数:
                        {details &&
                          details.recuperation_type_hospital_bed_group_medical_type_no_of_beds
                          ? details.recuperation_type_hospital_bed_group_medical_type_no_of_beds
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.recuperation_type_hospital_bed_group_medical_type_approved_date
                          ? details.recuperation_type_hospital_bed_group_medical_type_approved_date
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.recuperation_type_hospital_bed_group_medical_type_canceled_date
                          ? details.recuperation_type_hospital_bed_group_medical_type_canceled_date
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        介護型 看護種別:{" "}
                        {details &&
                          details.recuperation_type_hospital_bed_group_caregivingtype_nursingtype
                          ? details.recuperation_type_hospital_bed_group_caregivingtype_nursingtype
                          : "" + ","}
                        病床数:{" "}
                        {details &&
                          details.recuperation_type_hospital_bed_group_caregivingtype_noofbeds
                          ? details.recuperation_type_hospital_bed_group_caregivingtype_noofbeds
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.recuperation_type_hospital_bed_group_caregivingtype_approveddate
                          ? details.recuperation_type_hospital_bed_group_caregivingtype_approveddate
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.recuperation_type_hospital_bed_group_caregivingtype_canceleddate
                          ? details.recuperation_type_hospital_bed_group_caregivingtype_canceleddate
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        稼働数合計病床数:{" "}
                        {details &&
                          details.recuperation_type_hospital_bed_group_totalno_of_operationbeds
                          ? details.recuperation_type_hospital_bed_group_totalno_of_operationbeds
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>一般病棟</td>
                      <td>
                        {details && details.general_ward_flag
                          ? details.general_ward_flag
                          : ""}
                      </td>
                      <td>
                        看護種別:{" "}
                        {details && details.general_ward_nursing_type
                          ? details.general_ward_nursing_type
                          : "" + ","}
                        病床数:{" "}
                        {details && details.general_ward_number_of_beds
                          ? details.general_ward_number_of_beds
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>精神病棟</td>
                      <td>
                        {details && details.psychiatric_ward_flag
                          ? details.psychiatric_ward_flag
                          : ""}
                      </td>
                      <td>
                        看護種別:{" "}
                        {details && details.psychiatric_ward_nursing_type
                          ? details.psychiatric_ward_nursing_type
                          : "" + ","}
                        病床数:{" "}
                        {details && details.psychiatric_ward_number_of_beds
                          ? details.psychiatric_ward_number_of_beds
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>結核病棟</td>
                      <td>
                        {details && details.tuberculosis_ward_flag
                          ? details.tuberculosis_ward_flag
                          : ""}
                      </td>
                      <td>
                        看護種別:{" "}
                        {details && details.tuberculosis_ward_nursing_type
                          ? details.tuberculosis_ward_nursing_type
                          : "" + ","}{" "}
                        病床数:{" "}
                        {details && details.tuberculosis_ward_number_of_beds
                          ? details.tuberculosis_ward_number_of_beds
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>感染症_特定</td>
                      <td>
                        {details && details.infectious_disease_specific
                          ? details.infectious_disease_specific
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>感染症_1種</td>
                      <td>
                        {details && details.infectious_disease_type1
                          ? details.infectious_disease_type1
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>感染症_2種</td>
                      <td>
                        {details && details.infectious_disease_type2
                          ? details.infectious_disease_type2
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>感染症病床</td>
                      <td>
                        {details && details.infectious_disease_bed_flag
                          ? details.infectious_disease_bed_flag
                          : ""}
                      </td>
                      <td>
                        病床数:{" "}
                        {details &&
                          details.infectious_disease_bed_number_of_beds
                          ? details.infectious_disease_bed_number_of_beds
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>緩和ｹｱ病棟設置病院</td>
                      <td>
                        {details &&
                          details.hospital_with_palliative_care_ward_flag
                          ? details.hospital_with_palliative_care_ward_flag
                          : ""}
                      </td>
                      <td>
                        病床数:
                        {details &&
                          details.hospital_with_palliative_care_ward_number_of_beds
                          ? details.hospital_with_palliative_care_ward_number_of_beds
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.hospital_with_palliative_care_ward_approvd_date
                          ? details.hospital_with_palliative_care_ward_approvd_date
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.hospital_with_palliative_care_ward_canceled_date
                          ? details.hospital_with_palliative_care_ward_canceled_date
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>医療機能評価</td>
                      <td>
                        {details && details.medical_function_evaluation_flag
                          ? details.medical_function_evaluation_flag
                          : ""}
                      </td>
                      <td>
                        種別:{" "}
                        {details && details.medical_function_evaluation_type
                          ? details.medical_function_evaluation_type
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.medical_function_evaluation_certified_date
                          ? details.medical_function_evaluation_certified_date
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.medical_function_evaluation_canceled_date
                          ? details.medical_function_evaluation_canceled_date
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>臨床研修指定病院_基幹型病院1</td>
                      <td>
                        {details &&
                          details.clinical_training_hospital_primary_hospital_1_flag
                          ? details.clinical_training_hospital_primary_hospital_1_flag
                          : ""}
                      </td>
                      <td>-</td>
                      <td>
                        {details &&
                          details.clinical_training_hospital_primary_hospital_1_approved_date
                          ? details.clinical_training_hospital_primary_hospital_1_approved_date
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.clinical_training_hospital_primary_hospital_1_canceled_date
                          ? details.clinical_training_hospital_primary_hospital_1_canceled_date
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>臨床研修指定病院_基幹型病院2(郡指定)</td>
                      <td>
                        {details &&
                          details.clinical_training_hospital_primary_hospital_2_grouped_flag
                          ? details.clinical_training_hospital_primary_hospital_2_grouped_flag
                          : ""}
                      </td>
                      <td>
                        協力病院:
                        {/* {subsidiaryList.join(",")} */}
                        {subsidiaryList &&
                          subsidiaryList.map((item, key) => {
                            return (
                              <a
                                key={key}
                                className="link"
                                onClick={() => goToOrgCustomer(item.oo_id)}
                              >
                                {/* item.legacy_unified_customer_code      /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                 /*  ? item.legacy_unified_customer_code + /* SAKAMOTO: AHDD-5861 Ultmarc code change */}
                                {item.unified_customer_code                /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                  ? item.unified_customer_code +           /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                  (subsidiaryList[key + 1] &&
                                    subsidiaryList[key + 1]
                                      .unified_customer_code               /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                    /*     .legacy_unified_customer_code      /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                    ? ","
                                    : "")
                                  : ""}
                              </a>
                            );
                          })}
                      </td>
                      <td>
                        {details &&
                          details.clinical_training_hospital_primary_hospital_2_approved_date
                          ? details.clinical_training_hospital_primary_hospital_2_approved_date
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.clinical_training_hospital_primary_hospital_2_canceled_date
                          ? details.clinical_training_hospital_primary_hospital_2_canceled_date
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>臨床研修指定病院_協力型病院(郡指定)</td>
                      <td>
                        {details &&
                          details.clinical_training_hospital_Subsidiary_hospital_grouped_flag
                          ? details.clinical_training_hospital_Subsidiary_hospital_grouped_flag
                          : ""}
                      </td>
                      <td>
                        基幹病院:
                        {clinicalTrainingList &&
                          clinicalTrainingList.map((item, key) => {
                            return (
                              <a
                                key={key}
                                className="link"
                                onClick={() => goToOrgCustomer(item.oo_id)}
                              >
                                {/* item.legacy_unified_customer_code       /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                 /*  ? item.legacy_unified_customer_code +  /* SAKAMOTO: AHDD-5861 Ultmarc code change */}
                                {item.unified_customer_code                 /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                  ? item.unified_customer_code +            /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                  (clinicalTrainingList[key + 1] &&
                                    clinicalTrainingList[key + 1]
                                      /*     .legacy_unified_customer_code       /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                      .unified_customer_code                /* SAKAMOTO: AHDD-5861 Ultmarc code change */
                                    ? ","
                                    : "")
                                  : ""}
                              </a>
                            );
                          })}
                      </td>
                      <td>
                        {details &&
                          details.clinical_training_hospital_Subsidiary_hospital_grouped_app_dt
                          ? details.clinical_training_hospital_Subsidiary_hospital_grouped_app_dt
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.clinical_training_hospital_Subsidiary_hospital_grouped_cncld_dt
                          ? details.clinical_training_hospital_Subsidiary_hospital_grouped_cncld_dt
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>災害拠点病院</td>
                      <td>
                        {details && details.disaster_base_hospital
                          ? details.disaster_base_hospital
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>救急医療_救急告示</td>
                      <td>
                        {details &&
                          details.emergency_medical_care_emergency_notification
                          ? details.emergency_medical_care_emergency_notification
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>救急医療_2次救急</td>
                      <td>
                        {details &&
                          details.emergency_medical_care_secondary_emergency
                          ? details.emergency_medical_care_secondary_emergency
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>救急医療_3次救急</td>
                      <td>
                        {details &&
                          details.emergency_medical_care_third_emergency
                          ? details.emergency_medical_care_third_emergency
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>救急告示診療所</td>
                      <td>
                        {details && details.emergency_notification_clinic
                          ? details.emergency_notification_clinic
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>治験中核病院</td>
                      <td>
                        {details && details.clinical_trial_core_hospital_flag
                          ? details.clinical_trial_core_hospital_flag
                          : ""}
                      </td>
                      <td>
                        {details && details.clinical_trial_core_hospital_type
                          ? details.clinical_trial_core_hospital_type
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.clinical_trial_core_hospital_approved_date
                          ? details.clinical_trial_core_hospital_approved_date
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.clinical_trial_core_hospital_canceled_date
                          ? details.clinical_trial_core_hospital_canceled_date
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>認知症疾患医療ｾﾝﾀｰ</td>
                      <td>
                        {details && details.dementia_disease_medical_center_flag
                          ? details.dementia_disease_medical_center_flag
                          : ""}
                      </td>
                      <td>-</td>
                      <td>
                        {details &&
                          details.dementia_disease_medical_center_approved_date
                          ? details.dementia_disease_medical_center_approved_date
                          : ""}
                      </td>
                      <td>
                        {details &&
                          details.dementia_disease_medical_center_canceled_date
                          ? details.dementia_disease_medical_center_canceled_date
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>特定健康診査実施機関</td>
                      <td>
                        {details &&
                          details.organization_for_conducting_specific_health_check
                          ? details.organization_for_conducting_specific_health_check
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>特定保健指導実施機関</td>
                      <td>
                        {details &&
                          details.organization_for_implementation_of_specific_health_guidance
                          ? details.organization_for_implementation_of_specific_health_guidance
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>先進医療・高度医療技術実施医療機関</td>
                      <td>
                        {details &&
                          details.advanced_medical_care_implementation_facility_flag
                          ? details.advanced_medical_care_implementation_facility_flag
                          : ""}
                      </td>
                      <td>{implementationFacilityData}</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>先端医療機器</td>
                      <td>
                        {details && details.advanced_medical_equipment_flag
                          ? details.advanced_medical_equipment_flag
                          : ""}
                      </td>
                      <td>{medicalEquipmentData}</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>政策医療</td>
                      <td>
                        {details && details.policy_health_care_flag
                          ? details.policy_health_care_flag
                          : ""}
                      </td>
                      <td>{policyHealthData}</td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>訪問看護ステーション</td>
                      <td>
                        {details && details.home_visit_nursing_station_flag
                          ? details.home_visit_nursing_station_flag
                          : ""}
                      </td>
                      <td></td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                    <tr>
                      <td>開設年月</td>
                      <td>-</td>
                      <td>
                        {details && details.opening_Month
                          ? details.opening_Month
                          : ""}
                      </td>
                      <td>-</td>
                      <td>-</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="md"
        className="withdraw-modal"
        show={customerNotFound}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="warning-msg">
            <img src="images/warning2.svg" alt="Warning" /> Customer Not Found
          </div>
          <p className="mb-3">
            {lang("errorMessages.SEARCH_CUSTOMERS")}
            <a
              className="link"
              onClick={(e) => {
                changeRoute(e, "/organizationCustomer");
              }}
            >
              {lang("Menu.organizationCustomer")}
            </a>
          </p>
        </Modal.Body>
      </Modal>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    details: state.organizationCustomer.orgDetails,
  };
};

export default HospitalFunctions;
